import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Step1 from '../calendar/components/checkout/Step1'
import Step2 from '../calendar/components/checkout/Step2'
import Config from '../calendar/util/config'
import dayjs from 'dayjs'

const App = () => {
  const steps = [
    Step1,
    Step2,
  ]
  const startDate = dayjs(Config.get('selected'), 'Y-m-d')
  const endDate = React.useMemo(() => {
    return startDate.add(Config.get('nights'), 'days')
  }, [])

  const [ step, setStep ] = React.useState<number>(0)
  const [ data, setData ] = React.useState<any>({
    calendar_key: Config.get('calendarKey'),
    properties: [
      {
        cottage_id: Config.get('propertyCode'),
        arrival: {
          date: startDate.format('YYYY-MM-DD'),
        },
        departure: {
          date: endDate.format('YYYY-MM-DD'),
        },
        guests: {
          adults: 2,
          children: 0,
          infants: 0,
        },
      },
    ],
  })
  const CurrentStep: any = steps[step]

  return <div>
    <CurrentStep
      data={data}
      setData={setData}
      nextStep={() => setStep(step + 1)}
      setLargePopup={() => {}}
    ></CurrentStep>
  </div>
}

const setup = (elementId: string): void => {
    const element: HTMLElement = document.getElementById(elementId);

    if (!element)
      return

    try {
        Config.setAll(JSON.parse(element.dataset['options']));
    } catch (err) {
        // JSON parse failed we don't care
    }

 
    ReactDOM.render(
        <App />,
        element
    );
}

export default {
    setup,
}

